import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestBodyMinute } from '../../sub-page/minutes/interface/minute-detail';
import { RegisterMinutesService } from '../../service/register-minutes.service';
import Swal from 'sweetalert2';
import { DatePipe, formatCurrency, getCurrencySymbol } from '@angular/common';
import { provideNgxMask } from 'ngx-mask';
import { CompanyLinesDTO } from '../../interface/company-client.interface';
import { Router } from '@angular/router';
import { RegisterMinuteViewModel } from '../../interface/company-minutes.interface';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { SendNotification } from 'src/app/layouts/full/interface/headers.interface';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-register-minutes',
  templateUrl: './register-minutes.component.html',
  styleUrls: ['./register-minutes.component.scss'],
  providers: [provideNgxMask()],
})
export class RegisterMinutesComponent implements OnInit {
  public rutCompany: number;
  public isMinuteCreate: boolean = false;
  public booleanFlag: boolean;
  public requestBody: RequestBodyMinute;
  public fecha: Date = new Date();
  public fecha1: string;

  constructor(
    public dialogRef: MatDialogRef<RegisterMinutesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegisterMinuteViewModel,
    private service: RegisterMinutesService,
    private router: Router,
    private notification: NotificationsService,
    private authService: AuthService,
  ) {
    this.rutCompany = data.companyId;
  }

  ngOnInit(): void {
    this.service.getCompanyLines(this.rutCompany).subscribe({
      next: (response) => this.setForm(response),
    });
    this.fechaExpiracionDefault();
  }

  public fechaExpiracionDefault() {
    this.fecha = new Date();
    this.fecha.setDate(this.fecha.getDate() + 30);
  }

  private setForm(companyLines: CompanyLinesDTO) {
    this.formRegisterMinute.patchValue({
      line: companyLines.factoringLine.toString(),
      warrantyLine: companyLines.warrantyLine.toString(),
    });
  }

  formRegisterMinute = new FormGroup({
    line: new FormControl('', [Validators.required]),
    warrantyLine: new FormControl('', [Validators.required, Validators.min(0)]),
    dueDate: new FormControl(),
    description: new FormControl(),
    hasConditions: new FormControl(false)
  });

  get f() {
    return this.formRegisterMinute.controls;
  }

  onDateChange(event: any) {
    this.fecha1 = event.target.value;
  }
  
  alertNotification(action: string) {
    const id = parseInt(this.authService.getRutUser());
    const request: SendNotification = {
      action,
      companyId: this.rutCompany ,
      date: new Date(),
      userId: id,
      type: 1
    };  
    /*this.notification
      .createNotifications(request)
      .subscribe((a) => console.log(a));*/
  }

  submit() {
    const { line, dueDate, description, warrantyLine, hasConditions } = this.formRegisterMinute.value;

    if(this.fecha1 == null) {
      this.requestBody = {
        clientCompanyId: this.rutCompany,
        line: line,
        warrantyLine: Number(warrantyLine),
        duedate: null,
        description: description,
        operationIds: this.data.operationIds,
        hasConditions: false
        //duedate: new Date(dueDate).toISOString(),
      };
    }
    else {
      this.requestBody = {
        clientCompanyId: this.rutCompany,
        line: line,
        warrantyLine: Number(warrantyLine),
        duedate: this.fecha1,
        hasConditions: false
      };
    }

    this.booleanFlag = true;
    this.service.resgiterMinute(this.requestBody).subscribe({
      next: (next) => {
        this.booleanFlag = false;
        Swal.fire({
          title: 'Registro Realizado',
          icon: 'success',
        }).then((result) => {
          if (result.isConfirmed) {
            this.router.navigate(['/dashboards/minute'], {
              queryParams: { id: next.value.minuteRequestId },
            });
            //this.alertNotification('Minuta Creada')
            this.dialogRef.close(this.isMinuteCreate);
            this.isMinuteCreate = true;
          }
        });

        console.log(next.value.minuteRequestId);
      },
      error: (error) => {
        Swal.fire({
          title: 'Error',
          text: error.error,
          icon: 'error',
          timerProgressBar: true,
        });
        this.booleanFlag = false;

        console.log(error);
      },
    }); 
  }
  cerrarDialogo() {
    this.dialogRef.close();
  }
}
